import { Node } from "@tiptap/core";
import { mergeAttributes } from "@tiptap/core";
import { PAGE_HEADER_HEIGHT_PX } from "../constants";

export const PageHeader = Node.create({
    name: "pageHeader",
    group: "block",
    content: "headerImage",

    addAttributes() {
        return {};
    },

    parseHTML() {
        return [
            {
                tag: 'div[data-type="page-header"]',
            },
        ];
    },

    renderHTML({ HTMLAttributes }) {
        return [
            "div",
            mergeAttributes(HTMLAttributes, {
                "data-type": "page-header",
                class: "page-header",
                style: `height: ${PAGE_HEADER_HEIGHT_PX}px; overflow: hidden; background-color: #f0f0f0;`,
                contenteditable: "false",
            }),
            0,
        ];
    },
});
